import React, { useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import { sendEmail } from "../utils/emailUtils";

const Test = () => {
    const header = ["Firstname", "Lastname", "Age"];
    const body = [
        ["Edison", "Padilla", 14],
        ["Cheila", "Rodrigez", 56],
    ];

    /**
     * @description:
     *  also accepts an array of objects; the method (downloadExcel) will take
     *  as order of each column, the order that each property of the object brings with it.
     *  the method(downloadExcel) will only take the value of each property.
     */
    const body2 = [
        { firstname: "Edison", lastname: "Padilla", age: 14 },
        { firstname: "Cheila", lastname: "Rodrigez", age: 56 },
    ];

    function handleDownloadExcel() {
        downloadExcel({
            fileName: "react-export-table-to-excel -> downloadExcel method",
            sheet: "react-export-table-to-excel",
            tablePayload: {
                header,
                // accept two different data structures
                body: body || body2,
            },
        });
    }

    const [emailStatus, setEmailStatus] = useState<string>("");

    async function handleSendTestEmail() {
        setEmailStatus("Sending...");
        try {
            await sendEmail({
                to: ["dhirajchande@gmail.com"],
                subject: "Test Email from mtops-portal",
                html: "<b>This is a test email sent via Resend API.</b>",
                text: "This is a test email sent via Resend API.",
            });
            setEmailStatus("Email sent successfully!");
        } catch (err) {
            setEmailStatus("Failed to send email.");
        }
    }

    return (
        <div>
            {/* <button onClick={handleDownloadExcel}>download excel</button> */}
            <button style={{marginLeft:8}} className="btn btn-primary" onClick={handleSendTestEmail}>Send Test Email</button>
            {emailStatus && <div style={{marginTop:8}}>{emailStatus}</div>}
            <table>
                <tbody>
                    <tr>
                        {header.map((head) => (
                            <th key={head}> {head} </th>
                        ))}
                    </tr>

                    {body.map((item, i) => (
                        <tr key={i}>
                            {item.map((it) => (
                                <td key={it}>{it}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Test;
